import React from 'react'
import styled from '@emotion/styled'
import Modal from '../layout/Modal'
import { ModalContentNoBorder } from '../generic/Basics.js'
import Button from '../generic/button'
import WhereIsMyVin from './VinLocation.js'
import { breakpoints } from '../../constants'
import { fontSizeXSmall, fontSize2XSmall } from '../../constants/principles'

export default ({ setShowModal }) => (
  <Modal data-testid={'bi-modal-where-is-my-vin'} name="VIN">
    <StyledModalContent>
      <ModalPad>
        <ModalTitle>Where's my VIN?</ModalTitle>
        <ModalText>The Vehicle Identification Number (VIN) always has exactly 17 characters and can be found on the driver's doorjamb, driver side dashboard, vehicle registration card or insurance card.</ModalText>
        <WhereIsMyVin />
        <CenterDiv>
          <DoneButton data-testid={'bi-btn-where-is-my-vin-close'} onClick={e => setShowModal(false)}>Close</DoneButton>
        </CenterDiv>
      </ModalPad>
    </StyledModalContent>
  </Modal>
)

const ModalPad = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
const ModalTitle = styled.h2`
  font-size: ${fontSizeXSmall};
  font-weight: bold;
`
const StyledModalContent = styled(ModalContentNoBorder)`
  padding-top: 8px;
  overflow: hidden;
  -ms-overflow-style: none;
  width: 250px;
  height: 525px;
`
const DoneButton = styled(Button)`
  margin-top: 16px;
`
const ModalText = styled.div`
  font-size: 12px;
  padding-bottom: 8px;
  text-align: left;
`
const CenterDiv = styled.div`
  align-self: center;
`
